import * as React from "react";

import { IconClose } from "../icons/IconClose";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";

export const IconButtonClose: React.FC<MprcIconButtonProps> = ({ title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonClose.title;
    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconClose fixedWidth />
        </MprcIconButton>
    );
};
